export function get( selector, context = document ) {
    return context.querySelector( selector );
}
export function getAll( selector, context = document ) {
    return context.querySelectorAll( selector );
}
export function getById( id ) {
    return document.getElementById( id );
}
export function getByTag( tagName ) {
    return document.getElementsByTagName( tagName );
}